import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';

const Accordion = withStyles({
  root: {
    backgroundColor: 'inherit',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      marginBlock: 'auto',
    },
    '&.Mui-disabled': {
      backgroundColor: 'transparent',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles(() => ({
  root: {
    backgroundColor: 'inherit',
    padding: '0',
    minHeight: 24,
    '&$expanded': {
      minHeight: 24,
    },
    marginBottom: -1,
    '&.Mui-disabled': {
      opacity: 1,
    },
  },
  content: {
    margin: '0',
    '&$expanded': {
      margin: '0',
    },
  },
  expanded: {},
  expandIcon: {},
}))(MuiAccordionSummary);

const AccordionDetails = withStyles(() => ({
  root: {
    padding: '0',
    marginTop: 8,
  },
}))(MuiAccordionDetails);

export const StyledAccordion = {
  Accordion,
  AccordionSummary,
  AccordionDetails,
};
